import { autoserialize, autoserializeAs, serialize, serializeAs } from 'cerialize';
import { UserModel } from './user.model';
import { INucTableAction, INucTableItem } from '@relayter/rubber-duck';

export enum CONTRACT_OPTIONS {
    YEAR = 'Year',
    MONTH = 'Month'
}

export enum RATE_LIMIT_GROUPS {
    USER = 'USER',
    TEAM = 'TEAM',
    WEBHOOK_ENDPOINT = 'WEBHOOK_ENDPOINT',
    OAUTH_CLIENT = 'OAUTH_CLIENT'
}

export class RateLimitBurstModel {
    @autoserialize public rps: number = 0;
    @autoserialize public duration: number = 0;
}

export class RateLimitModel {
    constructor(group: RATE_LIMIT_GROUPS) {
        this.group = group;
    }

    @autoserialize public group: RATE_LIMIT_GROUPS;
    @autoserialize public rps: number = 0;
    @autoserializeAs(RateLimitBurstModel) public burst: RateLimitBurstModel = new RateLimitBurstModel();
}

export class ContractModel {
    @autoserialize public period: CONTRACT_OPTIONS;
    @autoserializeAs(Date) public startDate: Date;
}

export class TeamModel implements INucTableItem {
    @autoserialize public _id: string;
    @autoserialize public name: string;
    @autoserializeAs(UserModel) public owner: UserModel;
    @autoserialize public disabled: boolean;
    @autoserialize public userLimit: number;
    @autoserialize public userCount: number;
    @autoserialize public permissions: string[] = [];
    @autoserialize public storageLimit: number;
    @autoserialize public publicationItemLimit: number;
    @autoserialize public indesignGenerationLimit: number;
    @autoserialize public svgGenerationLimit: number;
    @autoserialize public afterEffectsGenerationLimit: number;
    @autoserialize public storageUsed: number;
    @autoserialize public publicationItemCreatedInCurrentContractPeriod: number;
    @autoserialize public indesignGenerationsInCurrentContractPeriod: number;
    @autoserialize public svgGenerationsInCurrentContractPeriod: number;
    @autoserialize public afterEffectsGenerationsInCurrentContractPeriod: number;
    @autoserialize public renderCredits: number;
    @autoserialize public renderCreditsUsedInCurrentContractPeriod: number;
    @autoserialize public afterEffectsCreditsPerUnit: number;
    @autoserialize public svgCreditsPerUnit: number;
    @autoserialize public indesignCreditsPerUnit: number;
    @autoserializeAs(ContractModel) public contract: ContractModel;
    @autoserializeAs(RateLimitModel) public rateLimits: RateLimitModel[] = [];

    public actions: INucTableAction[];

    get status() {
        return this.disabled ? 'Disabled' : 'Active';
    }
}

export class TeamPatchModel {
    @serialize public disabled: boolean;
    @serialize public userLimit: number;
    @serialize public storageLimit: number;
    @serialize public publicationItemLimit: number;
    @serialize public indesignGenerationLimit: number;
    @serialize public svgGenerationLimit: number;
    @serialize public afterEffectsGenerationLimit: number;
    @serialize public renderCredits: number;
    @serialize public afterEffectsCreditsPerUnit: number;
    @serialize public svgCreditsPerUnit: number;
    @serialize public indesignCreditsPerUnit: number;
    @serializeAs(ContractModel) public contract: ContractModel;
    @autoserialize public permissions: string[];
    @autoserializeAs(RateLimitModel) public rateLimits: RateLimitModel[];

    constructor(
        disabled?: boolean,
        userLimit?: number,
        storageLimit?: number,
        publicationItemLimit?: number,
        indesignGenerationLimit?: number,
        svgGenerationLimit?: number,
        afterEffectsGenerationLimit?: number,
        renderCredits?: number,
        afterEffectsCreditsPerUnit?: number,
        svgCreditsPerUnit?: number,
        indesignCreditsPerUnit?: number,
        contractModel?: ContractModel,
        permissions?: string[]
    ) {
        this.disabled = disabled;
        this.userLimit = userLimit;
        this.storageLimit = storageLimit;
        this.publicationItemLimit = publicationItemLimit;
        this.indesignGenerationLimit = indesignGenerationLimit;
        this.svgGenerationLimit = svgGenerationLimit;
        this.afterEffectsGenerationLimit = afterEffectsGenerationLimit;

        this.afterEffectsCreditsPerUnit = afterEffectsCreditsPerUnit;
        this.svgCreditsPerUnit = svgCreditsPerUnit;
        this.indesignCreditsPerUnit = indesignCreditsPerUnit;

        this.renderCredits = renderCredits;

        this.permissions = permissions;

        if (contractModel) {
            this.contract = contractModel;
        }
    }
}
